<script setup lang="ts">
const title = 'Kde nás najdete?';
const textAddress = 'Hůrka 1832, 530 12 Pardubice - Dubina';
const textBusinessId = 'IČO: 17355346';
</script>

<template>
  <div class="gap-r3 text-client-black flex flex-col">
    <AppHeading tag="h4">{{ title }}</AppHeading>
    <AppLink
      type="text"
      to="https://maps.app.goo.gl/KE6t9huGUyz3nvht8"
      :opts="{ link: { external: true, target: '_blank' } }"
      class="text-client-gray-darker"
    >
      {{ textAddress }}
    </AppLink>
    <AppParagraph class="text-client-gray-darker">
      {{ textBusinessId }}
    </AppParagraph>
  </div>
</template>
